import React from 'react';
import I18n from '@/modules/i18n';
import { BringToFront, SendToBack } from '@carbon/react/icons';
import cn from '@/utils/cn';
import ColorPicker from '../../Toolbar/ColorPicker';
import Action from '../Action';
import useDrawingContext from '../../store/useDrawingContext';
import icons from '../../Toolbar/icons';

interface SharedActionsProps {
  showColorPicker?: boolean;
}

const SharedActions = ({ showColorPicker }: SharedActionsProps) => {
  const duplicateObject = useDrawingContext(state => state.duplicateObject);
  const deleteObject = useDrawingContext(state => state.deleteObject);
  const moveObjects = useDrawingContext(state => state.moveObjects);
  const color = useDrawingContext(state => state.color);
  const { alt, icon } = icons.color;

  return (
    <>
      {showColorPicker && (
        <Action
          className="tw-w-[35px]"
          PopoverContent={<ColorPicker />}
          tooltipContent={I18n.t('change_color')}
        >
          <div
            aria-label={alt}
            className={cn(
              'tw-flex tw-items-center tw-justify-center tw-w-[17px] tw-h-[17px] tw-rounded tw-border-[1px]',
              'tw-border-solid tw-border-gray-300',
            )}
            role="button"
            style={{
              backgroundColor: (color as string),
              backgroundImage: `url(${icon})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
          />
        </Action>
      )}
      <Action
        className="fa fa-clone tw-w-[35px]"
        tooltipContent={I18n.t('copy')}
        onClick={() => duplicateObject()}
      />
      <Action
        className="tw-w-[35px]"
        tooltipContent={I18n.t('send_to_back')}
        onClick={() => moveObjects('back')}
      >
        <SendToBack height={18} width={18} />
      </Action>
      <Action
        className="tw-w-[35px]"
        tooltipContent={I18n.t('bring_to_front')}
        onClick={() => moveObjects('front')}
      >
        <BringToFront height={18} width={18} />
      </Action>
      <Action
        className="fa fa-trash tw-text-red tw-w-[35px] tw-ml-2"
        tooltipContent={I18n.t('delete')}
        onClick={() => deleteObject()}
      />
    </>
  );
};

export default SharedActions;
